module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow-c9bb14de50670754c93f0bfac04cc481.png";